import "./styles/App.css";
import Window from "./components/Window/Window";
import { Component } from "react";

class App extends Component {
  render() {
    return <Window />;
  }


}

export default App;
